<script setup lang="ts">
import { useEquipmentInfo } from '/@entities/equipment/api/useEquipmentInfo';
import { Resource } from '/@types/resources';

const props = defineProps<{
  resource: Resource;
}>();

const { equipmentInfo, equipmentLoading } = useEquipmentInfo(() => props.resource.guid);
</script>

<template>
  <div v-if="resource.groupType" class="dl__group dl__group--large">
    <dt class="dl__topic">Type</dt>
    <dd class="dl__description">
      <div class="badge">{{ resource.groupType }}</div>
    </dd>
  </div>

  <div class="dl__group dl__group--large" v-if="resource.name">
    <h2 class="dl__topic">Utstyr</h2>
    <p class="dl__description">{{ resource.name }}</p>
  </div>

  <template v-if="equipmentLoading">
    <div class="dl__group dl__group--large dl__group--horizontal">
      <div class="dl__description">
        <div class="loading-icon"></div>
      </div>
    </div>
  </template>

  <template v-else>
    <template v-for="entry in equipmentInfo" :key="entry.label">
      <div class="dl__group dl__group--sub" :class="{ 'dl__group--large': entry.large }">
        <h2 class="dl__topic">{{ entry.label }}</h2>
        <p class="dl__description">{{ entry.value || '-' }}</p>
      </div>
    </template>
  </template>
</template>
